<template>
  <div v-if="snackbars.length > 0" class="app-snackbars-wrapper">
    <div v-if="leftSnackbars.length > 0" class="app-snackbars left">
      <app-snackbar
        v-for="snackbar in leftSnackbars"
        :key="snackbar.id"
        :ref="`snackbar-${snackbar.id}`"
        direction="left"
        v-bind="snackbar"
      />
    </div>

    <div v-if="bottomSnackbars.length > 0" class="app-snackbars bottom">
      <app-snackbar
        v-for="snackbar in bottomSnackbars"
        :key="snackbar.id"
        :ref="`snackbar-${snackbar.id}`"
        v-bind="snackbar"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSnackbars',

  props: {
    direction: {
      type: String,
      default: 'left',
    },
  },

  computed: {
    snackbars() {
      return this.$attrs.snackbars ?? []
    },

    leftSnackbars() {
      return this.snackbars
        .filter(snackbar => snackbar.direction === 'left')
        .reverse()
    },

    bottomSnackbars() {
      return this.snackbars.filter(snackbar => snackbar.direction === 'bottom')
    },
  },

  methods: {
    showSnackbar(snackbar) {
      const snackbarComponent = this.$refs?.[`snackbar-${snackbar.id}`]?.[0]

      if (!snackbarComponent) return

      snackbarComponent.$on('closed', () => this.$emit('closed', snackbar))

      return snackbarComponent.open()
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@use '@/styles/settings.scss' as *;

.app-snackbars {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;

  > .app-snackbar {
    margin: #{math.div($defaultPadding, 3)} $defaultPadding;
  }

  &.left {
    bottom: auto;
    top: 20%;
    right: 20%;

    > .app-snackbar {
      max-width: 256px;
      margin-left: math.div($defaultPadding, 2);
    }
  }
}
</style>
